/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Flower = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Flower"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#5E1FF0"
      d="M11.215 2.56A.83.83 0 0 1 12 2c.352 0 .666.224.785.56v.001l.002.004.003.01.013.036.045.136q.058.177.156.5c.129.43.3 1.043.47 1.784.338 1.465.681 3.455.696 5.54v.131a23 23 0 0 1-.159 2.47c.334-.419.695-.837 1.083-1.24l.038-.038.002-.002.037-.037c1.25-1.257 2.655-2.234 3.74-2.896a22 22 0 0 1 1.761-.968l.11-.052.031-.015.01-.004h.002l.002-.002a.83.83 0 0 1 .927.172.85.85 0 0 1 .175.938v.001l-.001.003-.004.009-.014.03-.052.113q-.067.147-.195.408a24 24 0 0 1-.753 1.388c-.648 1.107-1.606 2.54-2.837 3.815l-.036.037-.002.001-.002.002-.001.002-.036.036c-.414.416-.845.802-1.276 1.156 1.242.02 2.414.272 3.273.515a15 15 0 0 1 1.384.469l.084.034.024.01.007.004h.003l.001.001a.84.84 0 0 1 .504.774.85.85 0 0 1-.503.775l-.003.001-.007.003-.024.01-.084.035q-.11.045-.306.12c-.26.096-.631.225-1.08.353-.744.214-1.725.435-2.783.506a10 10 0 0 1 .643.782 7 7 0 0 1 .176.251l.011.017.004.006.002.003c.17.266.18.606.023.88a.83.83 0 0 1-.765.42h-.03a5 5 0 0 1-.304-.03 9 9 0 0 1-.796-.128c-.633-.13-1.483-.373-2.28-.828l-.018-.011h-.001l-.003-.002-.002-.001-.017-.01c-.783-.466-1.418-1.086-1.853-1.583-.435.497-1.07 1.117-1.853 1.582l-.017.01-.002.002-.004.002-.002.001-.017.01c-.796.455-1.646.697-2.279.828a9 9 0 0 1-1.1.157l-.02.001h-.011a.83.83 0 0 1-.764-.42.85.85 0 0 1 .023-.88v-.002l.002-.001.004-.006.01-.017a5 5 0 0 1 .177-.251 9 9 0 0 1 .643-.782 13.5 13.5 0 0 1-2.784-.506 15 15 0 0 1-1.385-.473l-.084-.035-.024-.01-.007-.003-.002-.001h-.002A.84.84 0 0 1 2 17.835c0-.337.2-.64.505-.774l.003-.001.007-.003.024-.01.084-.035q.11-.046.306-.118c.26-.096.63-.223 1.078-.35.859-.244 2.03-.496 3.274-.516-.432-.354-.863-.74-1.277-1.156l-.038-.038-.001-.002-.002-.001-.035-.037c-1.232-1.275-2.19-2.708-2.838-3.815a23 23 0 0 1-.948-1.796l-.052-.112-.014-.031-.004-.01-.001-.002a.85.85 0 0 1 .175-.937.83.83 0 0 1 .928-.171h.001l.003.001.009.004.03.015.11.052q.144.07.4.2c.338.175.812.433 1.362.768 1.085.662 2.49 1.64 3.74 2.896l.038.038.002.002.001.001.036.037c.388.402.75.82 1.083 1.239a23 23 0 0 1-.16-2.47v-.069l.001-.062c.014-2.085.358-4.075.695-5.54a29 29 0 0 1 .627-2.284l.045-.136.013-.036.003-.01.001-.004z"
      className="SVG"
    />
  </svg>
);

export const FlowerIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'flower-icon'}
      icon={Flower}
      {...props}
      size={size}
    />
  );
};
